import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';

export class RandomLayout implements particles.ParticleLayout {
	public get(count: number, position: geometry.Vector2, size: geometry.Size): Array<particles.ParticleLookupProps> {
		let points: Array<particles.ParticleLookupProps> = [];
		for (let i = 0; i < count; i++) {
			points.push({
				x: position.x + Math.random() * size.w,
				y: position.y + Math.random() * size.h
			});
		}

		return points;
	}
}
